module.exports = __webpack_public_path__ + "img/0-123.3274303d.jpg";